export const API_BASE_URL = '/api';
export const APP_TITLE_PREFIX = 'Promété';
